import { z } from "zod";

export const CloudinarySignatureSchema = z.object({
  timestamp: z.string(),
  signature: z.string(),
  apiKey: z.string(),
  uploadPreset: z.string(),
  cloudName: z.string(),
  folder: z.string().nullable().optional(),
});

export type CloudinarySignature = z.infer<typeof CloudinarySignatureSchema>;
